import { useRemoteMutation } from "../../useRemote/useRemoteMutation";
import { RemoteApiError } from "../../useRemote/types";

export function useRemoteDeleteRoomlayout() {
  return useRemoteMutation<void, RemoteApiError, { ids: number[] }>({
    key: ["delete-room-layouts"],
    url: `/room-layouts/delete`,
    method: "post",
    snackbarTextFunOnFail: error => `${(error as any).response.data.message}`
  });
}
